import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState, useEffect } from "react";
import { Load } from "../load/load";
import { eliminarAlmacenMateriasPrimas } from "../../api/almacenMateriasPrimas";
import queryString from "query-string";
import { LogsInformativos } from "../logs/logs";

export default function EliminarAlmacenMP({ data, history, setShow }) {

    const dataTemp = {
        producto: data[1],
        inicial: data[2],
        minimo: data[3],
        maximo: data[4],
    };

    const [formData, setFormData] = useState(initialFormValue(dataTemp));
    //load
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simula una carga de datos
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, []);

    //insert
    const onSubmit = (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            // Sube a cloudinary la imagen principal del producto
            eliminarAlmacenMateriasPrimas(data[0]).then((response) => {
                const { data } = response;
                //notificacion

                toast.success(data.mensaje);
                LogsInformativos("Se ha eliminado el movimiento del producto " + data[0] + " en el almacen de materias primas", dataTemp)
                history({
                    search: queryString.stringify(""),
                });
                setLoading(false);
                setShow(false);
                //cancelarRegistro()
            });
        } catch (e) {
            console.log(e);
        }
    };

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <>
            {loading && <Load />}
            <div className="contact-form">
                <Form onSubmit={onSubmit} onChange={onChange}>
                    <br />
                    <Form.Control
                        placeholder="Producto"
                        type="text"
                        name="producto"
                        defaultValue={formData.producto}
                        disabled
                    />
                    <br />
                    <Form.Control
                        placeholder="inicial"
                        type="text"
                        name="inicial"
                        defaultValue={formData.inicial}
                        disabled
                    />
                    <Form.Control
                        placeholder="pedidoStock"
                        type="text"
                        name="minimo"
                        defaultValue={formData.minimo}
                        disabled
                    />
                    <br />
                    <Form.Control
                        placeholder="pedidoMinimo"
                        type="text"
                        name="maxico"
                        defaultValue={formData.maximo}
                        disabled
                    />
                    <br />
                    <label></label>
                    <input className="submit" value="Enviar" type="submit" />
                </Form>
            </div>
        </>
    );
}
function initialFormValue(data) {
    return {
        producto: data.producto,
        inicial: data.inicial,
        minimo: data.minimo,
        maximo: data.maximo,
    };
}
